import request from "@/utils/request/request";

export function getUserInfo(params) {
    return request({
        url : "wx",
        method : "GET",
        params
    })
}